module.exports = __webpack_public_path__ + "assets/img/1.c8c040e5.jpg";